export const CONSENT = {
  ACCEPTED: '1',
  REJECTED: '0',
};
